import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Badge, Card, Col, Container, Row } from "react-bootstrap";
import { getRecentAreaPaths, getRecentAreas } from "../common/recentAreas";

const Home = () => {
  const { user: currentUser } = useSelector((state) => state.auth);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const isService = Boolean(currentUser.serviceType);
  const isAdmin = currentUser.roles && currentUser.roles.includes("ROLE_ADMIN");
  const username = currentUser.username || "there";

  const defaultAreas = isService
    ? []
    : [
        {
          to: "/workstation-manager",
          icon: "bi-pc-display",
          title: "Workstations",
          description: "Manage workstation registrations and status.",
        },
        {
          to: "/mobile-device-manager",
          icon: "bi-phone",
          title: "Mobile Devices",
          description: "Review mobile device access.",
        },
        {
          to: "/inventory",
          icon: "bi-box-seam",
          title: "Inventory",
          description: "Open the inventory list.",
        },
        ...(isAdmin
          ? [
              {
                to: "/media-client",
                icon: "bi-camera",
                title: "Media Clients",
                description: "Manage PhotoBase media clients.",
              },
            ]
          : []),
      ];
  const recentAreaCount = getRecentAreaPaths(currentUser).length;
  const quickLinks = getRecentAreas(currentUser, defaultAreas);

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col xl={10}>
          <div className="bg-white border shadow-sm p-4 p-md-5 mb-4" style={{ borderRadius: "16px" }}>
            <Badge bg="light" text="dark" className="border px-3 py-2 rounded-pill mb-3">
              <i className="bi bi-check-circle text-success me-1"></i>
              Signed in
            </Badge>
            <h1 className="fw-bold mb-3" style={{ color: "var(--text-main)" }}>
              Welcome, {username}
            </h1>
            <p className="lead mb-0" style={{ color: "var(--text-muted)", maxWidth: "720px" }}>
              You are in the PartsKick Portal. Choose a workspace from the navigation menu or return to one of your recent areas below.
            </p>
          </div>

          {isService ? (
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-4">
                <div className="d-flex align-items-center">
                  <div
                    className="bg-info text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "44px", height: "44px" }}
                  >
                    <i className="bi bi-hdd-network"></i>
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1">Service access is active</h5>
                    <p className="mb-0" style={{ color: "var(--text-muted)" }}>
                      This account is connected for service integrations.
                    </p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ) : (
            <>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h2 className="h5 fw-bold mb-0" style={{ color: "var(--text-main)" }}>
                {recentAreaCount > 0 ? "Recent Areas" : "Common Areas"}
              </h2>
            </div>
            <Row className="g-3">
              {quickLinks.map((item) => (
                <Col md={6} xl={3} key={item.to}>
                  <Card as={Link} to={item.to} className="h-100 border-0 shadow-sm text-decoration-none">
                    <Card.Body className="p-4">
                      <div
                        className="bg-light rounded-circle d-flex align-items-center justify-content-center mb-3"
                        style={{ width: "46px", height: "46px", color: "#4f46e5" }}
                      >
                        <i className={`bi ${item.icon}`}></i>
                      </div>
                      <h5 className="fw-bold mb-2" style={{ color: "var(--text-main)" }}>
                        {item.title}
                      </h5>
                      <p className="mb-0" style={{ color: "var(--text-muted)" }}>
                        {item.description}
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Home;
